class CustomRingSize extends HTMLElement {
  connectedCallback() {
    this.select = this.querySelector('.custom-ring-size__select');
    this.errorEl = this.querySelector('.custom-ring-size__error');
    this.form = document.getElementById(this.dataset.formId);
    if (!this.select || !this.form) return;

    this._onSubmit = this._onSubmit.bind(this);
    this.form.addEventListener('submit', this._onSubmit, true);
    this.select.addEventListener('change', () => this._clearError());
  }

  disconnectedCallback() {
    if (this.form) this.form.removeEventListener('submit', this._onSubmit, true);
  }

  _onSubmit(e) {
    if (!this.select.value) {
      e.preventDefault();
      e.stopImmediatePropagation();
      this._showError();
      this.select.focus();
      this.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  _showError() {
    this.errorEl.textContent = this.dataset.requiredMessage;
    this.errorEl.hidden = false;
    this.classList.add('custom-ring-size--error');
  }

  _clearError() {
    this.errorEl.hidden = true;
    this.classList.remove('custom-ring-size--error');
  }
}

if (!customElements.get('custom-ring-size')) {
  customElements.define('custom-ring-size', CustomRingSize);
}
